'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { FireAlarm } from 'foundations-components/transitional/components/FireAlarm';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import ResendVerificationEmailButton from './ResendVerificationEmailButton';
import { EMAIL_CONFIRM_ACTIONS_ID, HUBSPOT_EMAIL_CONFIRM_BAR_ID } from '../constants/DOMSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EmailConfirmBarTemplate = email => /*#__PURE__*/_jsxs(FireAlarm, {
  type: "info",
  use: "inline",
  id: HUBSPOT_EMAIL_CONFIRM_BAR_ID,
  children: [/*#__PURE__*/_jsx(Text, {
    as: "p",
    display: "inline",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "emailConfirmBar.title",
      options: {
        email
      }
    })
  }), ' ', /*#__PURE__*/_jsx(View, {
    as: "div",
    display: "inline",
    id: EMAIL_CONFIRM_ACTIONS_ID,
    children: ResendVerificationEmailButton()
  })]
});
export default EmailConfirmBarTemplate;